import {ControlBuilder} from '../dynamic-field/control-builder.type';
import {FieldTypeEnum} from '../dynamic-field/field-type.enum';
import {numberFieldControlBuilder} from './number/number-field.builder';
import {textFieldControlBuilder} from './text/text-field.builder';
import {textareaFieldControlBuilder} from './textarea/text-area-field.builder';
import {checkboxFieldControlBuilder} from './checkbox/checkbox-field.builder';
import {multiOptionFieldControlBuilder} from './multi-option/multi-option.builder';
import {chipsFieldControlBuilder} from './chips/chips-field.builder';
import {chipsMultiSelectFieldControlBuilder} from './chips-multiselect/chips-multiselect-field.builder';
import {SlideToggleFieldControlBuilder} from './slidetoggle/slide-toggle.builder';
import {FilterSelectControlBuilder} from './filter-select/filter-select.builder';
import {buttonToggleFieldControlBuilder} from './button-toggle/button-toggle.builder';
import {fileSelectFieldBuilder} from './file-select/file-select-field.builder';
import {signatureFieldControlBuilder} from './signature/signature-field.builder';

export const fieldTypeToControlBuilder = new Map<FieldTypeEnum, ControlBuilder>([
    [FieldTypeEnum.number, numberFieldControlBuilder],
    [FieldTypeEnum.text, textFieldControlBuilder],
    [FieldTypeEnum.textarea, textareaFieldControlBuilder],
    [FieldTypeEnum.checkbox, checkboxFieldControlBuilder],
    [FieldTypeEnum.multiOption, multiOptionFieldControlBuilder],
    [FieldTypeEnum.chips, chipsFieldControlBuilder],
    [FieldTypeEnum.chipsMultiSelect, chipsMultiSelectFieldControlBuilder],
    [FieldTypeEnum.slidetoggle, SlideToggleFieldControlBuilder],
    [FieldTypeEnum.filterSelect, FilterSelectControlBuilder],
    [FieldTypeEnum.buttonToggle, buttonToggleFieldControlBuilder],
    [FieldTypeEnum.fileSelect, fileSelectFieldBuilder],
    [FieldTypeEnum.signature, signatureFieldControlBuilder]
]);
